export default "__VITE_ASSET__FzfYN69Y__"